import { css as _css } from "@emotion/core";
var _excluded = ["visible", "align", "icon", "onPointerEnter", "onPointerLeave"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './navigation-button.style';
import logEventForComponent from '../../utils/log-event-for-component';
import { jsx as ___EmotionJSX } from "@emotion/core";
var logEvent = logEventForComponent('NavButton');
var NavigationButton = _ref => {
  var visible = _ref.visible,
    align = _ref.align,
    icon = _ref.icon,
    onPointerEnter = _ref.onPointerEnter,
    onPointerLeave = _ref.onPointerLeave,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.navigationButton, align === 'left' ? styles.left : styles.right]),
    onPointerEnter: onPointerEnter,
    onPointerLeave: onPointerLeave
  }, ___EmotionJSX("button", _extends({
    css: /*#__PURE__*/_css([styles.button, visible ? styles.show : styles.hide]),
    "aria-label": "Previous Photo",
    type: "button"
  }, props, {
    onClick: logEvent('onClick', props.onClick)
  }), icon));
};
NavigationButton.propTypes = {
  icon: PropTypes.element,
  align: PropTypes.oneOf(['left', 'right']),
  visible: PropTypes.bool,
  onPointerEnter: PropTypes.func,
  onPointerLeave: PropTypes.func,
  onClick: PropTypes.func
};
NavigationButton.defaultProps = {
  icon: undefined,
  align: 'left',
  visible: false,
  onPointerEnter: () => {},
  onPointerLeave: () => {},
  onClick: () => {}
};
export default NavigationButton;